export default "__VITE_ASSET__B57My3gE__"